import { useLocation } from 'react-router-dom';
const storeKey = 'redirectAfterLoginTo';
const defaultPath = '/';
export default function useRedirectAfterLogin() {
    const location = useLocation();
    const saveCurrentLocation = () => {
        const fullPath = location.pathname + location.search;
        localStorage.setItem(storeKey, fullPath);
    };
    const getRedirectPath = () => {
        const redirectPath = localStorage.getItem(storeKey);
        localStorage.removeItem(storeKey);
        return redirectPath || defaultPath;
    };
    return {
        saveCurrentLocation,
        getRedirectPath
    };
}
